export default "__VITE_ASSET__hIUiXkin__"